import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	personAvatarLabel: {
		id: 'search-page.profile-avatar.label',
		defaultMessage: 'Person Avatar',
		description: 'Default person avatar icon for users',
	},
});
